export class InfoSeparacaoPedidoDTO {
    public Filial: string;
    public Pedido: string;
    public PrePedido: string;
    public Produtos: ProdutoSeparacaoDTO[];
    constructor(data: any = {}) {
        this.Filial = data.Filial || data.FILIAL;
        this.Pedido = data.Pedido || data.PEDIDO;
        this.PrePedido = data.PrePedido || data.PREPEDIDO;
        this.Produtos = data.Produtos && data.Produtos.map(e => new ProdutoSeparacaoDTO(e));

    }
}

export class ProdutoSeparacaoDTO {

    public CodigoProduto: string;

    public DescricaoProduto: string;

    public QuantidadePedido: number;

    public Valor: number;

    public QuantidadeEntregue: number;

    public ValorEntregue: number;

    public Residuo: string;

    public QuantidadeSeparacao: number;

    public PrcSeparacao: number;

    public ValorSeparacao: number;


    constructor(data: any = {}) {
        this.CodigoProduto = data.CodigoProduto;
        this.DescricaoProduto = data.DescricaoProduto;
        this.QuantidadePedido = data.QuantidadePedido;
        this.Valor = data.Valor;
        this.QuantidadeEntregue = data.QuantidadeEntregue;
        this.ValorEntregue = data.ValorEntregue;
        this.Residuo = data.Residuo;
        this.QuantidadeSeparacao = data.QuantidadeSeparacao;
        this.PrcSeparacao = data.PrcSeparacao;
        this.ValorSeparacao = data.ValorSeparacao;
    }
}